import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { fetchOrderInfo } from "../../actions/index";
import PaymentCard from "../../components/PaymentCard";
import "../../static/style/checkout.css";

const queryString = require("query-string");

class CheckoutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDisplay: false
    };
  }

  componentDidMount() {
    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      this.props.fetchOrderInfo({
        order_number: parsed.order_number,
        amount: parsed.amount,
        customer_id: parsed.customer_id
      });
    }
  }

  getOrderAmount() {
    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      return parsed.amount;
    }
    return 0;
  }
  getOrderNumbert() {
    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      return parsed.order_number;
    }
    return 0;
  }
  onShowCustomerDetails() {
    const current = this.state.isTableDisplay;
    this.setState({
      isTableDisplay: !current
    });
  }

  render() {
    return this.props.isLoading ? (
      <h1 className="header1">
        <FormattedMessage id="app.loading" defaultMessage="Ladataan..." />
      </h1>
    ) : (
      <div className="paymentinfo-container">
        {this.props.orderInfo.client ? (
          <div className="customer-container">
            <p className="customer-title">
              <FormattedMessage
                id="checkout.customer"
                defaultMessage="Maksun tiedot"
              />
            </p>
            <ul className="customer-details">
              <li>
                <span>
                  <FormattedMessage
                    id="checkout.amount"
                    defaultMessage="Maksun summa"
                  />:
                </span>
                <span className="amount-value">{this.getOrderAmount()} €</span>
              </li>
              <li>
                <span>
                  <FormattedMessage
                    id="checkout.reference_number"
                    defaultMessage="Viitenumero"
                  />:
                </span>
                <span>{this.getOrderNumbert()}</span>
              </li>
              <li>
                <span>
                  <FormattedMessage
                    id="checkout.customer_details"
                    defaultMessage="Maksun saaja/toimittaja"
                  />:
                </span>
                <span>{this.props.orderInfo.client.nimi}</span>
                <span
                  className="customer-details-btn"
                  onClick={() => this.onShowCustomerDetails()}
                >
                  {this.state.isTableDisplay ? (
                    <FormattedMessage
                      id="checkout.customer_details.hide"
                      defaultMessage="(Piilota tiedot)"
                    />
                  ) : (
                    <FormattedMessage
                      id="checkout.customer_details.show"
                      defaultMessage="(Näytä tiedot)"
                    />
                  )}
                </span>
              </li>
              <div
                className="table-container"
                style={{
                  maxHeight: this.state.isTableDisplay ? "210px" : 0
                }}
              >
                <table className="table-customer-details">
                  {this.props.orderInfo.client ? (
                    <tr>
                      <td>
                        <FormattedMessage
                          id="checkout.customer_details.number"
                          defaultMessage="Tunnus"
                        />
                      </td>
                      <td>{this.props.orderInfo.client.tunnus}</td>
                    </tr>
                  ) : null}
                  {this.props.orderInfo.client.yhteydenottoemail ? (
                    <tr>
                      <td>
                        <FormattedMessage
                          id="checkout.customer_details.email"
                          defaultMessage="Email"
                        />
                      </td>
                      <td>{this.props.orderInfo.client.yhteydenottoemail}</td>
                    </tr>
                  ) : null}
                </table>
              </div>
            </ul>
          </div>
        ) : null}
        <p className="providers-title">
          <FormattedMessage
            id="checkout.provider"
            defaultMessage="VALITSE MAKSUTAPA"
          />
        </p>
        <div className="providers-container">
          {this.props.orderInfo.paymentInfo.providers.map(provider => (
            <div className="provider-card-container">
              <PaymentCard provider={provider} />
            </div>
          ))}
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: this.props.orderInfo.paymentInfo.terms
          }}
          className="paytrail-terms"
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  fetchOrderInfo: orderInfo => dispatch(fetchOrderInfo(orderInfo))
});

const mapStateToProps = function(store) {
  return {
    orderInfo: store.order.orderInfo,
    isLoading: store.order.isLoading
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CheckoutPage)
);



// WEBPACK FOOTER //
// ./src/containers/Payment/Checkout.js